import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[clickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(
      event.target as HTMLElement,
    );
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }

  @HostListener('document:touchstart', ['$event'])
  public onTouchStart(event: TouchEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(
      event.target as HTMLElement,
    );
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
